<template>
  <div class="feed-games">
    <div class="form__row">
      <input :class="{'form__input': true, 'is-error': errors.has('feedName')}"
             type="text"
             v-validate="'required'"
             placeholder="Feed Name"
             v-model="feedName"
             v-input-trim
             >
    </div>

    <div class="form__row" v-if="chosenFeed">
      <FilterInput title="Filter games by slug"
                   :filterList="games"
                   :filterByKey="filterFields"
                   v-on:filter="onFilterGames"
      ></FilterInput>
    </div>

    <Loader v-if="isGamesLoadInProgress"></Loader>

    <div v-if="chosenFeed">
      <div class="form__row">
        <label><strong>Selected Games: {{selectedGames.length}}</strong></label>
      </div>
      <div class="form__row">
        <div class="feed-game-list__container">
          <ul class="feed-game-list">
            <li
              class="feed-game-list__item"
              v-for="(game, index) in filteredGames"
              :key="index">
              <label class="form__checkbox-label">
                <input type="checkbox"
                       :value="game"
                       v-model="selectedGames"
                       v-on:change="checkBoxChange(game)"
                >
                <strong>{{game.name}}</strong>
                <label>{{game.slug}}</label>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../../config'
  import Loader from '../../Loader/Loader.vue'
  import FilterInput from '../../FilterInput/FilterInput.vue'

  export default {
    name: 'FeedsGames',
    components: {Loader, FilterInput},
    props: ['chosenFeed', 'chooseFeed', 'games'],
    data () {
      return {
        allGames: [],
        selectedGames: [],
        filteredGames: [],
        isGamesLoadInProgress: false,
        filterFields: ['slug'],
        addGames: [],
        deleteGames: [],
        feedName: ''
      }
    },
    watch: {
      chosenFeed: {
        immediate: 'Enter feed name here',
        handler(newVal, oldVal) {
          if (newVal) {
            this.feedName = newVal.name
          }
        }
      }
    },
    created: function () {
      this.allGames = this.games.map(item => {
        this.resetGame(item)
        return item
      })
      this.filteredGames = this.games
      this.fdName = this.chosenFeed ? this.chosenFeed.name : ''
    },
    methods: {
      checkBoxChange: function (game) {
        if (game && this.selectedGames.find(g => g.id === game.id)) {
          this.addGames.push(game);
          this.deleteGames = this.deleteGames.filter(function( g ) {
            return g.id !== game.id;
          });
        } else {
          this.deleteGames.push(game);
          this.addGames = this.addGames.filter(function( g ) {
            return g.id !== game.id;
          });
        }
      },
      onFilterGames: function (games) {
        this.filteredGames = games
      },
      getChosenFeedGames: function (feed) {
        this.isGamesLoadInProgress = true

        // reset all game list to initial state
        this.games.forEach(game => {
          this.resetGame(game)
        })

        this.$gameApi.get(`/feeds/${feed.id}`)
          .then(feed => {
            this.selectedGames = []
            let feedGames = feed.feedGames;
            // reconstruct UI-bound properties
            this.games.forEach(game => {
              let feedGame = feedGames.find(feedGame => feedGame.game.id === game.id)
              if (feedGame) {
                game.alias = feedGame.alias
                game.new_name = feedGame.name
                game.description = feedGame.description
                game.categories = feedGame.categories
                game.version = feedGame.version
                game.membersOnly = feedGame.membersOnly
                game.metaHTMLTitle = feedGame.metaHTMLTitle
                game.metaHTMLDescription = feedGame.metaHTMLDescription
                game.rules = feedGame.rules
                game.arkMetaData = feedGame.arkMetaData
                game.selectedMetaData = feedGame.selectedMetaData
                game.feedId = feed.id

                this.selectedGames.push(game)
              }
            })
            this.filteredGames = this.games
            this.isGamesLoadInProgress = false
          }, error => {
            this.isGamesLoadInProgress = false
            console.log(error)
          })
      },
      resetGame: function (game) {
        // add additional properties for UI data binding
        game.alias = ''
        // use 'new_name' property to hold localized names, since original 'name' property is used in UI data binding
        game.new_name = []
        game.description = []
        game.categories = []
        game.membersOnly = false
        game.metaHTMLTitle = []
        game.rules = []
        game.metaHTMLDescription = []
        game.arkMetaData = {}
        game.selectedMetaData = null
      },
      getSelectedGames: function () {
        let gamesToSave = []
        this.selectedGames.forEach(game => {
          gamesToSave.push({
            id: game.id,
            slug: game.slug,
            alias: game.alias,
            description: game.description,
            categories: game.categories,
            name: game.new_name,
            version: game.version,
            membersOnly: game.membersOnly,
            metaHTMLTitle: game.metaHTMLTitle,
            metaHTMLDescription: game.metaHTMLDescription,
            rules: game.rules,
            arkMetaData: game.arkMetaData,
            selectedMetaData: game.selectedMetaData
          })
        })

        return gamesToSave
      },
      getFeedName: function () {
        return this.feedName;
      },
      getGamesToFeed: function () {
        return this.addGames;
      },
      getGamesToDeleteFromFeed: function () {
        return this.deleteGames;
      },
      validateForm: function () {
        return this.$validator.validateAll()
      }
    }
  }
</script>

<style scoped src="./FeedGames.scss" lang="scss"></style>
